/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de
 * (Modul: detectSystem->localFontDetector, detectSystem->detectRemoteFontBlocker)
 *
 * @version 3.1.56
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// Instanziere swfobject
let swfobject = require('swfobject');

/**
 * enum für die verschiedenen FontDetect-Engines
 */
enum DetectEngine {
    Flash = 0,
    Javascript = 1,
}

/**
 * Übermittelte Font-Liste
 * @type {Array}
 */
let detectedFontList:string[] = [];

/**
 * Liste mit Schriften
 * @type {Array}
 */
const fontList = [
    "ADOBE CASLON PRO", "ADOBE GARAMOND PRO", "ARCHER", "ARNO PRO", "AVENIR", "Academy Engraved LET", "AcademyEngravedLetPlain", "Adobe Garamond", "Agency FB", "Aharoni", "AlNile", "Algerian", "Amazone BT", "AmerType Md BT", "American Typewriter", "AmericanTypewriter", "AmericanTypewriter-CondensedBold", "AmericanTypewriter-CondensedLight", "Andale Mono", "Andalus", "Angsana New", "AngsanaUPC", "Antique Olive", "Aparajita", "Apple Chancery", "Apple Color Emoji", "Apple SD Gothic Neo", "AppleColorEmoji", "AppleSDGothicNeo-Regular", "Arabic Typesetting", "Arial", "Arial Hebrew", "Arial MT", "Arial Narrow", "Arial Unicode MS", "Arial-BoldMT", "Arial-ItalicMT", "ArialHebrew", "ArialMT", "ArialRoundedMTBold", "Arrus BT", "Aurora Cn BT", "AvantGarde Bk BT", "AvantGarde Md BT", "Avenir-Book", "Avenir-BookOblique", "Avenir-LightOblique", "Avenir-MediumOblique", "Avenir-Oblique", "Avenir-Roman", "AvenirNext-MediumItalic", "AvenirNext-Regular", "AvenirNextCondensed-MediumItalic", "AvenirNextCondensed-Regular", "Ayuthaya", "Bandy", "Bangla Sangam MN", "BanglaSangamMN", "Bank Gothic", "BankGothic Md BT", "Baskerville", "Baskerville Old Face", "Batang", "BatangChe", "Bauer Bodoni", "Bauhaus 93", "Bazooka", "Bell MT", "Bembo", "Benguiat Bk BT", "Berlin Sans FB", "Berlin Sans FB Demi", "BernhardFashion BT", "BernhardMod BT", "Big Caslon", "BinnerD", "Bitstream Vera Sans Mono", "Blackadder ITC", "BlairMdITC TT", "Bodoni 72", "Bodoni 72 Oldstyle", "Bodoni 72 Smallcaps", "Bodoni MT", "Bodoni MT Poster Compressed", "BodoniOrnamentsITCTT", "BodoniSvtyTwoITCTT-Book", "BodoniSvtyTwoITCTT-BookIta", "BodoniSvtyTwoOSITCTT-Book", "BodoniSvtyTwoOSITCTT-BookIt", "BodoniSvtyTwoSCITCTT-Book", "Book Antiqua", "Bookman Old Style", "Bookshelf Symbol 7", "Boulder", "Bradley Hand", "Bradley Hand ITC", "Bremen Bd BT", "Broadway", "Browallia New", "BrowalliaUPC", "Brush Script MT", "CG Omega", "CG Times", "Calibri", "Californian FB", "Calisto MT", "Calligrapher", "Cambria", "Cambria Math", "Candara", "CaslonOpnface BT", "Castellar", "Centaur", "Century", "Century Gothic", "Century Schoolbook", "Cezanne", "Chalkboard", "Chalkboard SE", "ChalkboardSE-Regular", "Chalkduster", "Charlesworth", "Charter BT", "Charter Bd BT", "Chaucer", "ChelthmITC Bk BT", "Chiller", "Clarendon", "CloisterBlack BT", "Cochin", "Colonna MT", "Comic Sans", "Comic Sans MS", "Consolas", "Constantia", "CopperplGoth Bd BT", "Copperplate", "Copperplate Gothic", "Corbel", "Cordia New", "CordiaUPC", "Cornerstone", "Coronet", "Courier", "Courier New", "Courier-BoldOblique", "Courier-Oblique", "CourierNewPS-BoldMT", "CourierNewPS-ItalicMT", "CourierNewPSMT", "Cuckoo", "Curlz MT", "DB LCD Temp", "DBLCDTempBlack", "DELICIOUS", "DFKai-SB", "DIN", "Damascus", "DamascusBold", "DamascusLight", "DamascusMedium", "DamascusSemiBold", "DaunPenh", "Dauphin", "David", "Denmark", "DevanagariSangamMN", "Didot", "DilleniaUPC", "DiwanMishafi", "DokChampa", "Dotum", "DotumChe", "EUROSTILE", "Ebrima", "Edwardian Script ITC", "Elephant", "English 111 Vivace BT", "Engravers MT", "EngraversGothic BT", "Eras Bold ITC", "Eras Demi ITC", "Eras Light ITC", "Eras Medium ITC", "EucrosiaUPC", "Euphemia", "Euphemia UCAS", "EuphemiaUCAS", "Exotc350 Bd BT", "FONTIN", "FRUTIGER", "FangSong", "Farah", "Felix Titling", "Fixedsys", "Forte", "FrankRuehl", "Fransiscan", "Freefrm721 Blk BT", "FreesiaUPC", "Freestyle Script", "French Script MT", "FrnkGothITC Bk BT", "Fruitger", "Futura", "Futura Bk BT", "Futura Lt BT", "Futura Md BT", "Futura ZBlk BT", "Futura-CondensedExtraBold", "Futura-CondensedMedium", "Futura-MediumItalic", "FuturaBlack BT", "GOTHAM", "GOTHAM BOLD", "Gabriola", "Galliard BT", "Garamond", "Gautami", "Geeza Pro", "GeezaPro", "Geneva", "GeoSlab 703 Lt BT", "GeoSlab 703 XBd BT", "Geometr231 BT", "Geometr231 Hv BT", "Geometr231 Lt BT", "Georgia", "Gigi", "Gill Sans", "Gill Sans MT", "GillSans", "GillSans-LightItalic", "Gisha", "Goudy Old Style", "Goudy Stout", "GoudyHandtooled BT", "GoudyOLSt BT", "Gujarati Sangam MN", "GujaratiSangamMN", "Gulim", "GulimChe", "Gungsuh", "GungsuhChe", "Gurmukhi MN", "GurmukhiMN", "HELV", "Haettenschweiler", "Harrington", "Heather", "Heiti SC", "Heiti TC", "Helvetica", "Helvetica Neue", "Helvetica-BoldOblique", "Helvetica-LightOblique", "Helvetica-Oblique", "HelveticaNeue", "HelveticaNeue-CondensedBlack", "HelveticaNeue-CondensedBold", "HelveticaNeue-LightItalic", "HelveticaNeue-MediumItalic", "Herald", "High Tower Text", "HiraKakuProN-W3", "HiraKakuProN-W6", "HiraMinProN-W3", "HiraMinProN-W6", "Hiragino Kaku Gothic ProN", "Hiragino Mincho ProN", "HiraginoSans-W3", "HiraginoSans-W6", "Hoefler Text", "HoeflerText-Regular", "Humanst 521 Cn BT", "Humanst521 BT", "Humanst521 Lt BT", "INCONSOLATA", "INTERSTATE", "Impact", "Imprint MT Shadow", "Incised901 BT", "Incised901 Bd BT", "Incised901 Lt BT", "Informal Roman", "Informal011 BT", "IowanOldStyle-Roman", "IrisUPC", "Iskoola Pota", "JasmineUPC", "Jazz LET", "Jenson", "Jester", "Jokerman", "Juice ITC", "Kabel Bk BT", "Kabel Ult BT", "KaiTi", "Kailasa", "Kalinga", "Kannada Sangam MN", "KannadaSangamMN", "Kartika", "Kaufmann BT", "Kaufmann Bd BT", "Khmer UI", "KhmerSangamMN", "KodchiangUPC", "KohinoorBangla-Regular", "KohinoorDevanagari-Book", "KohinoorTelugu-Regular", "Kokila", "Korinna BT", "Kristen ITC", "Krungthep", "Kunstler Script", "LUCIDA GRANDE", "Lao UI", "LaoSangamMN", "Latha", "Leelawadee", "Letter Gothic", "Levenim MT", "LilyUPC", "Lithograph", "Long Island", "Lucida Bright", "Lucida Calligraphy", "Lucida Console", "Lucida Fax", "Lucida Handwriting", "Lucida Sans", "Lucida Sans Typewriter", "Lucida Sans Unicode", "Lydian BT", "MONO", "MS Gothic", "MS LineDraw", "MS Mincho", "MS Outlook", "MS PGothic", "MS PMincho", "MS Reference Sans Serif", "MS Reference Specialty", "MS Sans Serif", "MS Serif", "MS UI Gothic", "MT Extra", "MUSEO", "MV Boli", "MYRIAD", "MYRIAD PRO", "Magneto", "Maiandra GD", "Malayalam Sangam MN", "MalayalamSangamMN", "Malgun Gothic", "Mangal", "Marigold", "Marion", "Marion-Regular", "Marker Felt", "MarkerFelt-Wide", "Market", "Marlett", "Matisse ITC", "Matura MT Script Capitals", "Meiryo", "Meiryo UI", "Menlo-Regular", "Microsoft Himalaya", "Microsoft JhengHei", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Sans Serif", "Microsoft Tai Le", "Microsoft Uighur", "Microsoft YaHei", "Microsoft Yi Baiti", "MingLiU", "MingLiU-ExtB", "MingLiU_HKSCS", "MingLiU_HKSCS-ExtB", "Minion", "Minion Pro", "Miriam", "Miriam Fixed", "Mistral", "Modern", "Modern No. 20", "Mona Lisa Solid ITC TT", "Monaco", "Mongolian Baiti", "Monotype Corsiva", "MoolBoran", "Mrs Eaves", "NEVIS", "NSimSun", "Nadeem", "Narkisim", "News Gothic", "News GothicMT", "NewsGoth BT", "Niagara Engraved", "Niagara Solid", "Noteworthy", "Nyala", "OCR A Extended", "OPTIMA", "OSAKA", "Old Century", "Old English Text MT", "Onyx", "Onyx BT", "Optima-ExtraBlack", "Optima-Regular", "Oriya Sangam MN", "OriyaSangamMN", "OzHandicraft BT", "PMingLiU", "PMingLiU-ExtB", "PRINCETOWN LET", "PTBarnum BT", "Palace Script MT", "Palatino", "Palatino Linotype", "Palatino-Roman", "Papyrus", "Parchment", "Party LET", "PartyLetPlain", "Pegasus", "Perpetua", "Perpetua Titling MT", "PetitaBold", "Pickwick", "PingFangHK-Regular", "PingFangSC-Regular", "PingFangTC-Regular", "Plantagenet Cherokee", "Playbill", "Poor Richard", "Poster", "PosterBodoni BT", "Pristina", "Pythagoras", "Raavi", "Ravie", "Ribbon131 Bd BT", "Rockwell", "Rod", "Roman", "SCRIPTINA", "SILKSCREEN", "Sakkal Majalla", "SanFranciscoDisplay-Regular", "SanFranciscoRounded-Regular", "SanFranciscoText-BoldG1", "SanFranciscoText-BoldG2", "SanFranciscoText-BoldG3", "SanFranciscoText-LightItalic", "SanFranciscoText-MediumItalic", "SanFranciscoText-Regular", "SanFranciscoText-RegularG1", "SanFranciscoText-RegularG2", "SanFranciscoText-RegularG3", "SanFranciscoText-RegularItalic", "SanFranciscoText-RegularItalicG1", "SanFranciscoText-RegularItalicG2", "SanFranciscoText-RegularItalicG3", "SanFranciscoText-SemiboldItalic", "Santa Fe LET", "Savoye LET", "SavoyeLetPlain", "Sceptre", "Script", "Segoe Print", "Segoe Script", "Segoe UI", "Segoe UI Symbol", "Serifa", "Serifa BT", "Serifa Th BT", "ShelleyVolante BT", "Sherwood", "Shonar Bangla", "Showcard Gothic", "Shruti", "Signboard", "SimHei", "SimSun", "SimSun-ExtB", "Simplified Arabic", "Simplified Arabic Fixed", "Sinhala Sangam MN", "SinhalaSangamMN", "Sketch Rockwell", "Skia", "Small Fonts", "Snap ITC", "Snell Roundhand", "SnellRoundhand", "Socket", "Souvenir Lt BT", "Staccato222 BT", "Steamer", "Stencil", "Storybook", "Styllo", "Subway", "Superclarendon-LightItalic", "Superclarendon-Regular", "Swis721 BlkEx BT", "Swiss911 XCm BT", "Sylfaen", "Symbol", "Synchro LET", "System", "TRAJAN PRO", "Tahoma", "Tamil Sangam MN", "TamilSangamMN", "Technical", "Teletype", "Telugu Sangam MN", "TeluguSangamMN", "Tempus Sans ITC", "Terminal", "Thonburi", "Times", "Times New Roman", "Times New Roman PS", "TimesNewRomanPS-BoldMT", "TimesNewRomanPS-ItalicMT", "TimesNewRomanPSMT", "Traditional Arabic", "Trajan", "Trebuchet MS", "TrebuchetMS", "Tristan", "Tubular", "Tunga", "Tw Cen MT", "TypoUpright BT", "Unicorn", "Univers", "Utsaah", "Vagabond", "Vani", "Verdana", "Vijaya", "Viner Hand ITC", "VisualUI", "Vivaldi", "Vladimir Script", "Vrinda", "WHITNEY", "Westminster", "Wide Latin", "Wingdings", "Wingdings 2", "Wingdings 3", "ZWAdobeF", "ZapfDingbatsITC", "ZapfEllipt BT", "ZapfHumnst BT", "ZapfHumnst Dm BT", "Zapfin", "Zapfino", "Zurich BlkEx BT", "Zurich Ex BT"
];

/**
 *  Klasse zum prüfen ob eine Schriftart zur Verfügung steht
 */
class localFontAvailable {
    // Die zu prüfende Schrift gegen alle Standard-Schriften prüfen und
    // falls die Dimensionen mit keiner übereinstimmt, ist die Schrift verfügbar
    private baseFonts = [
        {font: 'monospace', defaultWidth: 0, defaultHeight: 0 },
        {font: 'sans-serif', defaultWidth: 0, defaultHeight: 0 },
        {font: 'serif', defaultWidth: 0, defaultHeight: 0 }
    ];

    // Test-String mit sehr breiten und schmalen Zeichen, damit die Schriftarten
    // gut außereinandergehalten werden können
    private testString = "mmmmmmmmmmlli";

    // Schriftgröße für den Test-Text (größer ist besser)
    private testSize = '72px';

    //private defaultWidth: { [key: string]: number };
    //private defaultHeight: { [key: string]: number };

    private h = document.getElementsByTagName("body")[0];
    private s = document.createElement("span");

    public constructor() {
        // DOM Objekt außerhalb des Bildbereichs setzen
        this.s.style.position = 'absolute';
        this.s.style.left = '-9999px';

        // DOM Objekt Design normalisieren und Schriftgröße setzen
        this.s.style.fontSize = this.testSize;
        this.s.style.fontStyle = 'normal';
        this.s.style.fontWeight = 'normal';
        this.s.style.letterSpacing = 'normal';
        this.s.style.lineBreak = 'auto';
        this.s.style.lineHeight = 'normal';
        this.s.style.textTransform = 'none';
        this.s.style.textAlign = 'left';
        this.s.style.textDecoration = 'none';
        this.s.style.textShadow = 'none';
        this.s.style.whiteSpace = 'normal';
        this.s.style.wordBreak = 'normal';
        this.s.style.wordSpacing = 'normal';

        // Test-Text setzen
        this.s.innerHTML = this.testString;

        // Dimensionen der Basis-Fonts ermitteln
        for (let index in this.baseFonts) {
            //get the default width for the three base fonts
            this.s.style.fontFamily = this.baseFonts[index].font;
            this.h.appendChild(this.s);

            this.baseFonts[index].defaultWidth = this.s.offsetWidth;
            this.baseFonts[index].defaultHeight = this.s.offsetHeight;

            this.h.removeChild(this.s);
        }
    }

    public detect(font:string) {
        let detected = false;

        for (let index in this.baseFonts) {
            this.s.style.fontFamily = font + ',' + this.baseFonts[index].font; // Name der zu prüfenden Schrift zusammen mit Base-Font als FallBack
            this.h.appendChild(this.s);
            let matched = (this.s.offsetWidth != this.baseFonts[index].defaultWidth || this.s.offsetHeight != this.baseFonts[index].defaultHeight);
            this.h.removeChild(this.s);
            detected = detected || matched;
        }

        return detected;
    }
}

/**
 * Einfache Klasse um festzustellen, ob eine Remote-Font erfolgreich geladen wurde
 */
export class detectRemoteFontBlocker {
    public static fontBlocked(fontname: string, success: Function, failed: Function) {
        let FontFaceObserver = require('fontfaceobserver');
        let testFont = new FontFaceObserver(fontname);

        testFont.load().then(success).catch(failed);
    }
}

/**
 * Erkennung von lokalen Schriften
 */
export class localFontDetector {
    /**
     * Starte Suche der installierten Schriften
     *
     * @param fontdetectswf string
     * @param fontdetectworker string
     * @param withStatusFlash Function
     * @param withStatusJS Function
     */
    public startSearch(
        fontdetectswf:string,
        fontdetectworker:string,
        withStatusFlash:Function,
        withStatusJS:Function
    ) {
        // Font-Erkennung initialisieren
        if (!swfobject.hasFlashPlayerVersion("9.0.0")) {
            // Beginne Font-Suche per Javascript
            withStatusJS();
            this.startJavascriptSearch(fontdetectworker);
        } else {
            // Beginne Font-Suche per Flash
            this.startFlashSearch(fontdetectswf);
            withStatusFlash();

            // Fall-Back falls die Flash-Animation nicht mehr reagiert
            setTimeout(() => {
                    if(detectedFontList.length === 0) {
                        $("#FontInfoBadge").remove();
                        withStatusJS();
                        console.warn("Flash-Plugin detected, but got no response from it. Falling back to JS Font-Detection");
                        this.startJavascriptSearch(fontdetectworker);
                    }
                },
                5000
            );

        }
    }

    // noinspection JSMethodCanBeStatic
    /**
     * Führe Erkennung der Schriften per Flash-Anwendung aus
     *
     * @param fontdetectswf
     */
    public startFlashSearch(fontdetectswf: string) {
        // Füge Flash-Anwendung in das DOM zurück
        swfobject.embedSWF(fontdetectswf, "fontdetectswf", "1", "1", "9.0.0");
    }

    /**
     * Führe Erkennung der Schriften per Javascript aus
     *
     * @param fontdetectworker string
     */
    public startJavascriptSearch(fontdetectworker: string) {
        // Badge: Wieviele Schriftarten wurden gefunden?
        let domStatusText = $( "#FontInfoBadge" );

        if ((<any>window).Worker) {
            /*
             * Starte Worker zur Erkennung der Fonts
             */

            // Lege Worker an und starte ihn
            let jsFontWorker = new Worker(fontdetectworker);
            jsFontWorker.postMessage(fontList);

            // Font-Tester
            let fontTester = new localFontAvailable();
            
            /**
             * Rückmeldung des Worker verarbeiten
             * @param e
             */
            jsFontWorker.onmessage = function(e) {
                // Initialisiere die Font-Liste
                if (e.data === "init") {
                    // noinspection JSNonASCIINames
                    let ueberschrift = "<li class=\"list-group-item\" id='detailFontListHeader'><strong>" +
                        DETECTPHRASE["Folgende"] + " " +
                        "0 von " + fontList.length.toString() + " " +
                        DETECTPHRASE["Schriften über Javascript erkannt"] +
                        ":</strong></li>";

                    // Font-Kopf-Liste zusammenstellen
                    // noinspection JSNonASCIINames
                    $("#hasFontList").html(
                        ueberschrift +
                        '<li class="list-group-item" id="detailFontList">' +
                        DETECTPHRASE["Erkennung der Schriften über Javascript beginnt"] +
                        '</li>'
                    );
                } else if(e.data === "done") {
                    // Liste mit Schriften wurde komplette verarbeitet
                    if(detectedFontList.length === 0) {
                        // Keine Schrift wurde erkannt
                        $("#FontInfoBadge").text(DETECTPHRASE["inaktiv"]);
                        $("#hasFontList").html(
                            '<li class="list-group-item">' + DETECTPHRASE["Schriften konnten nicht ermittelt werden (ben&ouml;tigt Adobe Flash oder JavaScript)"]+ '</li>'
                        );
                    }
                } else {
                    // Prüfe Font und füge ggf. in Detail-Liste hinzu
                    if( fontTester.detect(e.data.fontName) ) {
                        // Schrift wurde gefunden
                        detectedFontList.push(e.data.fontName);
                        localFontDetector.updateFontList(DetectEngine.Javascript, e.data.fontName, e.data.normalizedFontName);
                    }
                }
            }
        } else {
            /*
             * Ohne Worker-Support kann keine JS-Erkennung durchgeführt werden
             */
            let statusText = "Nicht aktiv";
            if ( domStatusText.length ) {
                domStatusText.text(statusText);
            } else {
                domStatusText.html('<span id="FontInfoBadge" class="badge">' + statusText + '</span>');
            }
            $("#hasFontList").html(
                '<li class="list-group-item">' +
                DETECTPHRASE["Schriften konnten nicht ermittelt werden (ben&ouml;tigt Adobe Flash oder Javascript)"] +
                '</li>'
            );
        }
    }

    /**
     * Funktion zum füllen der Font-Liste
     *
     * @param engine string
     * @param fontName string
     * @param sampleText string
     */
    public static updateFontList(engine:DetectEngine, fontName:string, sampleText:string) {
        // Badge: Wieviele Schriftarten wurden gefunden?
        let domStatusText = $( "#FontInfoBadge" );

        // Badge Text zusammenstellen
        if(engine === DetectEngine.Javascript) {
            domStatusText.html(detectedFontList.length + " von " + fontList.length.toString());
        } else {
            domStatusText.html(detectedFontList.length.toString());
        }
        
        // Überschrift zusammenstellen
        let engineText:string;
        let numberFonts:string;
        if(engine === DetectEngine.Javascript) {
            engineText = "Schriften über Javascript erkannt";
            numberFonts = detectedFontList.length.toString() + " von " + fontList.length.toString();
        } else {
            engineText = "Schriften wurden auf Ihrem System über Adobe Flash erkannt";
            numberFonts = detectedFontList.length.toString();
        }
        let ueberschrift = "<strong>" +
            DETECTPHRASE["Folgende"] + " " + numberFonts + " " +
            DETECTPHRASE[engineText] +
            ":</strong>";
        $("#detailFontListHeader").html(ueberschrift);

        // HTML String für Font zusammenstellen
        let detailFontList = $("#detailFontList");
        let prefix = "";
        if(detailFontList.text().length > 1) {
            prefix=", ";
        }
        let htmlString = "<span class=\"sample-text\" style=\"font-family: \'" + fontName + "\'; font-size: 1em; color:#aaa;\">"
            + sampleText + "</span>";
        detailFontList.append(prefix + htmlString);
    }
}

/**
 * Call-Back Funktion aufgerufen durch die Font-Detection Flash-Anwendung
 *
 * @param fontArray array
 */
window.populateFontList = (fontArray:string[]) => {
    // Liste mit Fonts bereinigen um nur die "Standard"-Ausführung zu ermitteln
    detectedFontList = fontArray.filter(function(e:string) {
        e = e.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        if (!e.match(/[_\-\s]Italic$/)
            && !e.match(/[_\-\s\w](Demi|Semi|Extra)?[Bb]old$/)
            && !e.match(/[_\-\s\w]Medium$/)
            && !e.match(/[_\-\s\w](Ultra)?[Ll]ight$/)
            && !e.match(/[_\-\s\w]Condensed$/)
            && !e.match(/[_\-\s\w]Kursiv/)
            && !e.match(/[_\-\s\w]Fett/)
            && !e.match(/[_\-\s\w]Heavy/)
            && !e.match(/[_\-\s\w]ExtraLight/)
            && !e.match(/[_\-\s\w]Thin/)
            && !e.match(/[_\-\s\w]Ultra/)
            && !e.match(/[_\-\s\w]Black/)
            && !e.match(/BoldItalic/)
        ) {
            return e;
        }
    });
    
    // Anzahl der Fonts ermitteln
    let regularFontsCounter:number = detectedFontList.length;

    // Wieviele Schriftarten wurden gefunden?
    let domStatusText = $( "#FontInfoBadge" );
    if(regularFontsCounter > 0) {
        /*
         * Mehr als 0 Schriften wurden erkannt
         */
        
        // Badge Text zusammenstellen und anlegen
        domStatusText.html(regularFontsCounter.toString());

        // noinspection JSNonASCIINames
        let ueberschrift = "<li class=\"list-group-item\" id='detailFontListHeader'><strong>" +
            DETECTPHRASE["Folgende"] + " " +
            regularFontsCounter.toString() + " " +
            DETECTPHRASE["Schriften wurden auf Ihrem System über Adobe Flash erkannt"] +
            ":</strong></li>";

        // Font-Kopf-Liste zusammenstellen
        $("#hasFontList").html( ueberschrift + '<li class="list-group-item" id="detailFontList"></li>' );

        // Fonts in Liste eintragen
        detectedFontList.forEach(function(e:string) {
            localFontDetector.updateFontList(DetectEngine.Flash, e, e.replace(/\s*Regular$/, ""));
        });
    } else {
        /*
         * Es wurden keine Schriften zurückgemeldet
         */
        let statusText = "Nicht aktiv";
        if ( domStatusText.length ) {
            domStatusText.text(statusText);
        } else {
            $("#fontListHeader").append('<span id="FontInfoBadge" class="badge">' + statusText + '</span>');
        }
        $("#hasFontList").html(
            '<li class="list-group-item">' + DETECTPHRASE["Schriften konnten nicht ermittelt werden (ben&ouml;tigt Adobe Flash oder Javascript)"] + '</li>'
        );
    }
};
